import CompleteSectionForm from '@Components/CompleteSectionForm/CompleteSectionForm';
import {
  enabledMarketingIndustryCompletedSectionEn,
  enabledMarketingIndustryCompletedSectionTh,
} from '@Router/NatureOfBusiness/completedSectionUtils';
import { useWatch } from 'react-hook-form';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import {
  MarketingIndustryFormValues,
  MarketingPolicyFormValues,
} from '../NatureOfBusinessFormProvider/types';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { Role } from 'src/Enum/Report';

const MarketPoliciesFormCompletionCheckbox = () => {
  const { isPublished } = useProgressBar();
  const marketingPolicy = useWatch({
    name: 'marketingIndustry.marketingPolicy',
  }) as MarketingPolicyFormValues[] | undefined;

  const marketingIndustry = useWatch({
    name: 'marketingIndustry',
  }) as MarketingIndustryFormValues;

  const completedSection = useWatch({
    name: `marketingIndustry.completedSection`,
  });
  const { setValue } = useNatureOfBusinessForm();

  return (
    <CompleteSectionForm
      checkSectionName="marketingIndustry.completedSection"
      enableCheckSectionTh={
        !isPublished &&
        enabledMarketingIndustryCompletedSectionTh(
          marketingPolicy,
          marketingIndustry
        )
      }
      enableCheckSectionEn={
        !isPublished &&
        enabledMarketingIndustryCompletedSectionEn(
          marketingPolicy,
          marketingIndustry
        )
      }
      onCompleteThChange={(checked) => {
        if (!checked) {
          setValue('marketingIndustry.completedSection', {
            ...completedSection,
            isCompletedTh: false,
            roleStampTh: Role.NONE,
            dateTh: undefined,
          });
        }
      }}
      onCompleteEnChange={(checked) => {
        if (!checked) {
          setValue('marketingIndustry.completedSection', {
            ...completedSection,
            isCompletedEn: false,
            roleStampEn: Role.NONE,
            dateEn: undefined,
          });
        }
      }}
    />
  );
};

export default MarketPoliciesFormCompletionCheckbox;
